import { API_ENDPOINTS } from './src-config-api-config.js';

let translationCache = {};
let locale;
const fetchTranslations = async (loc) => {
  try {
    if (loc) locale = loc;
    const response = await fetch(API_ENDPOINTS.TRANSLATIONS(loc || "en-us"));
    if (!response.ok) {
      throw new Error("Failed to fetch translations");
    }
    const translations = await response.json();
    translationCache = translations;
  } catch (error) {
    console.error(error);
    translationCache = {};
  }
};
const initTranslations = async (loc) => {
  if (Object.keys(translationCache).length === 0) {
    await fetchTranslations(loc);
  }
};
const t = (key) => {
  if (!translationCache || Object.keys(translationCache).length === 0) {
    initTranslations(locale).then(
      () => translationCache[key]
      // Fallback to key if translations are not available
    );
  }
  const transWord = translationCache[key];
  return transWord || key;
};

export { initTranslations, t };
//# sourceMappingURL=src-utils-translations.js.map
